
import { Job } from "@/models/job";
import { UblS3UploadedFile } from "@/plugins/ubl/models/ubl-archive-file";
import { ICreateUBLArchiveOptions, UblService } from "@/plugins/ubl/services/ubl-service";
import { JobService } from "@/services/job-service";
import { MainSocketService } from "@/services/main-socket-service";
import Vue from "vue";
import AppCreateUblArchiveModalForm from "./CreateUblArchiveModalForm.vue";
import AppCreateUblArchiveModalProgress from "./CreateUblArchiveModalProgress.vue";
import AppCreateUblArchiveModalCreated from "./CreateUblArchiveModalCreated.vue";

export default Vue.extend({
	data(){
		return {
			state: "form" as "form" | "creating" | "done",
			jobSubs: [] as string[],
			job: null as null | Job,
			createdArchive: null as UblS3UploadedFile | null,
		};
	},
	props: {
		isPurchase: Boolean,
		selectedIds: {
			type: Array as () => number[],
			default: () => []
		}
	},
	computed: {
		startedFromSelection(): boolean {
			return this.selectedIds.length > 0;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async onJobStarted(job:Job) {
			console.log("JOB STARTED");
			this.job = job;
		},
		handleError(){
			if (this.startedFromSelection) {
				this.close();
			}else{
				this.state = "form";
			}
		},
		subscribeToJob(j:Job){
			this.createdArchive = null;
			JobService.on(`job-stopped/${j.getID()}`, this.onJobStopped);
			JobService.on(`job-started/${j.getID()}`, this.onJobStarted);
			this.jobSubs.push(`job-stopped/${j.getID()}`);
			MainSocketService.on(`/plugins/ubl/created-archive/${j.getID()}`, this.onArchiveCreated, this);
		},
		async createFromSelection(){
			try{
				this.state = "creating";
				let j:Job;
				if (this.isPurchase) {
					j = await UblService.createPurchaseArchive(this, {purchaseIds: this.selectedIds});
				}else{
					j = await UblService.createArchive(this, {saleIds: this.selectedIds, typeIds: [1,2]});
				}
				this.subscribeToJob(j);
			}catch(err){
				this.close();
			}
		},
		async create(data:{beginDate:Date, endDate:Date, message:string, vatPeriod:number, journals:number[]}){
			try{
				this.state = "creating";
				if (this.isPurchase) {
					var j = await UblService.createPurchaseArchive(this, {
						beginDate: data.beginDate,
						endDate: data.endDate,
						message: data.message,
						vatPeriod: data.vatPeriod,
						journalIds: data.journals
					});
				}else{
					let d:ICreateUBLArchiveOptions = {
						startDate: data.beginDate,
						endDate: data.endDate,
						message: data.message,
						journalIds: data.journals,
						typeIds: [1,2]
					};
					var j = await UblService.createArchive(this, d);
				}
				this.subscribeToJob(j);
			}catch(err){
				this.state = "form";
			}
		},
		async onJobStopped(job:Job){
			if (this.createdArchive) return;
			if (job.Error) {
				this.handleError();
			}
		},
		async onArchiveCreated(archiveId:number){
			try{
				this.createdArchive = await UblService.getArchive(archiveId);
				this.state = "done";
				this.$emit("done");
			}catch(err){
				this.handleError();
			}
		}
	},
	mounted(){
		if (this.startedFromSelection) {
			this.createFromSelection();
		}
	},
	destroyed(){
		for (let jobSub of this.jobSubs){
			JobService.off(jobSub, this.onJobStopped);
		}
		MainSocketService.offAll(this);
	},
	components: {
		AppCreateUblArchiveModalForm,
		AppCreateUblArchiveModalProgress,
		AppCreateUblArchiveModalCreated
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
